// extracted by mini-css-extract-plugin
export default {"mainSection":"UserLayout_mainSection__JglJv","mainWrapper":"UserLayout_mainWrapper__MDzJ8","outletWrapper":"UserLayout_outletWrapper__swFY7"};